import { render } from "./CaricamentoRcu.vue?vue&type=template&id=d0b12a9c"
import script from "./CaricamentoRcu.vue?vue&type=script&lang=js"
export * from "./CaricamentoRcu.vue?vue&type=script&lang=js"

import "./CaricamentoRcu.vue?vue&type=style&index=0&id=d0b12a9c&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__